import { dispatchOverlayShareShow } from 'src/store/commonPart';
import { tryCatch } from 'src/utils/tryCatch';

export type ShareLinkType = 'Facebook' | 'Twitter' | 'Link';

export type ShareLinkType26794 = 'Facebook' | 'Twitter' | 'Link' | 'LinkedIn' | 'Email' | 'Mobile';

export const shareLink = (type: ShareLinkType, link: string) => {
  if (type === 'Link') {
    dispatchOverlayShareShow(link);
  } else {
    tryCatch(() => window.RallyUp.SocialLinksController[type](link));
  }
};

export const shareLink26794 = (
  type: ShareLinkType26794,
  link: string,
  MobileSharingTitle?: string,
  MobileSharingText?: string,
  EmailBody?: string,
  EmailSubject?: string,
  TextToGiveKeyWord?: string | null,
  TwilioDisplayedString?: string | null,
  SecondaryTwilioDisplayedString?: string | null,
  InternationalNumbersEnabled?: boolean,
  SharingEmailTemplate?: string | null
) => {
  if (type === 'Mobile') {
    tryCatch(() => window.RallyUp.SocialLinksController_26794.Mobile(link, MobileSharingTitle, MobileSharingText));
  } else if (type === 'Email') {
    tryCatch(() => window.RallyUp.SocialLinksController_26794.Email(EmailSubject, EmailBody));
  } else if (type === 'Link') {
    tryCatch(() =>
      window.RallyUp.SocialLinksController_26794.Link(
        link,
        TextToGiveKeyWord,
        TwilioDisplayedString,
        SecondaryTwilioDisplayedString,
        InternationalNumbersEnabled,
        SharingEmailTemplate
      )
    );
  } else {
    tryCatch(() => window.RallyUp.SocialLinksController_26794[type](link));
  }
};
